(function () {
	'use strict';

	angular.module('app.dashboard')
		.controller('genericProjectSavingsCtrl', genericProjectSavingsCtrl);

	genericProjectSavingsCtrl.$inject = ['$rootScope', '$scope', '$timeout', 'config', 'title', 'type', 'viewType', 'displayType',
		'dashboardFilterInitializationService', 'leanFilterService', 'pageTimingService', 
		'leanProjectGeneralSavingsService', 'storeService', 'leanProjectSummaryService'];

	function genericProjectSavingsCtrl($rootScope, $scope, $timeout, config, title, type, viewType, displayType,
			dashboardFilterInitializationService, leanFilterService, pageTimingService,
			leanProjectGeneralSavingsService, storeService, leanProjectSummaryService) {
		var initiativeChartProperties = {
			eventName: 'event:generalProjectSavingsCtrl:getChart', // event watched by directive
			fmtService: 'currencyFormatService', // Formatting service used for the values of the chart,
			translation: {
				'totalSavings': 'Total Savings',
				'annualSavings': 'Annual Savings',
				'oneTimeSavings': 'One Time Savings',
				'costAvoidence': 'Cost Avoidance',
				'implementationCost': 'Implementation Cost',
				'weightedSavings': 'Weighted Savings',
				'Areas': 'Area',
				'Sites': 'Site',
				'BusinessUnit': 'Business Unit'
			},
			savingsTypeFilterTranslation: {
				'totalSavings': 'Total Savings',
				'annualSavings': 'Annual Savings',
				'oneTimeSavings': 'One Time Savings',
				'costAvoidence': 'Cost Avoidance',
				'implementationCost': 'Implementation Cost',
				'weightedSavings': 'Weighted Target Savings'
			}
		};

		var configStr;
		$scope.modelDetails = $scope.$parent.model;
		if (!config.viewType) {
			configStr = $scope.modelDetails.configStr ? JSON.parse($scope.modelDetails.configStr) : {};
		} else {
			configStr = config;
		}
		viewType = configStr['viewType'];
		displayType = configStr['displayType'];
		$scope.filterService = dashboardFilterInitializationService;
		$scope.leanFilterService = leanFilterService;
		$scope.slideshowView = $rootScope.slideshowView;
		$scope.chartId = type;
		$scope.chartTitle = title;
		$scope.savingsSelect = !viewType;
		$scope.firstTime = !viewType;
		$scope.viewType = !viewType ? 'Areas' : viewType;
		$scope.displayType = !displayType ? 'target-totalSavings' : displayType;
		$scope.lastViewType = viewType;
		$scope.lastDisplayType = displayType;
		$scope.showTable = false;
		$scope.isReadOnly = storeService.getState().reportSettings.readOnly;
		$scope.toggleTable = getTable;
		$scope.getLink = getLink;
		$scope.$parent.$parent.editWidgetSettings = function () {
			$scope.savingsSelect = true;
			$scope.$parent.$parent.hidePencil = true;
		};

		$scope.getViewLabel = function() {
			return initiativeChartProperties.translation[$scope.viewType] + ($scope.categoriesCount <= 1 ? '' : 's');
		};

		function updateConfig(viewType, displayType) {
			var model = $scope.$parent.model;
			model.config.viewType = viewType;
			model.config.displayType = displayType;
			$scope.lastViewType = viewType;
			$scope.lastDisplayType = displayType;
			var columnDefinition = $scope.$parent.$parent.col;
			storeService.dispatch({
				type: storeService.actions.CONFIG_WIDGET_UPDATE_ONE,
				payload: {
					column: 'column' + columnDefinition.columnIndex,
					position: columnDefinition.widgets.indexOf(model),
					widget: {
						name: model.config.type,
						config: _.cloneDeep(model.config)
					}
				},
				meta: {
					reportName: undefined,
					reportSettingsId: globalReportName
				}
			});
		}

		$scope.closeDialog = function() {
			$scope.savingsSelect = false;
			$scope.$parent.$parent.hidePencil = false;
		};


		$scope.saveSavings = function (viewType, displayType) {
			if ((viewType !== null && viewType !== $scope.lastViewType) || (displayType !== null &&
					displayType !== $scope.lastDisplayType)) {
				pendo.track('widgetChangeConfig', {
					widgetType: $scope.config.type,
					viewType: viewType,
					displayType: displayType
				});
				updateConfig(viewType, displayType);
				$scope.firstTime = false;
				getChart();
				$scope.showTable = false;
			} else {
				$scope.savingsSelect = false;
				$scope.$parent.$parent.hidePencil = false;
			}
		};

		function setWidgetName() {
			if (!$scope.firstTime) {
				$scope.$parent.$parent.definition.config.title = 'Lean Projects by ' + initiativeChartProperties.translation[$scope.viewType];
			}
		}

		function setChartHeading() {
			if ($scope.displayType !== 'numberOfProjects') {
				var savingsBySavingType = $scope.displayType.split('-');
				$scope.savings = savingsBySavingType[1];
				$scope.mode = savingsBySavingType[0] === 'actual' ? 'Actual' : 'Target';
				$scope.currentMode = $scope.mode + ' ' + initiativeChartProperties.translation[$scope.savings];
				$scope.sortMode = $scope.mode;
			} else {
				$scope.sortMode = 'Count';
				$scope.savings = 'totalSavings';
			}
		}

		function getLink(row) {
			var url = '/application/f/home.html#/lean-projects/projects-kanban/?drilldown=1&';
			if ($scope.groupBy === 'BusinessUnit') {
				url += 'businessunit=' + encodeURIComponent(row.areaNdx);
			} else if ($scope.groupBy === 'Sites') {
				url += 'factory=' + row.areaNdx;
			} else {
				url += 'projectArea='  + encodeURIComponent(row.initiativeArea);
			}

			if ($scope.extraFilters) {
				url += '&' + $scope.extraFilters;
			}
			return url;
		}

		function getChart() {
			setWidgetName();
			var columnDefinition = $scope.$parent.$parent.col;
			var curWidget = $scope.$parent.model;
			leanProjectGeneralSavingsService.getLeanProjectSummary($scope.leanFilterService, $scope.viewType, $scope.displayType).then(
				function (d) {
					$scope.isCount = $scope.displayType === 'numberOfProjects';
					$scope.empty = false;
					setChartHeading();
					if (!d || !d.data.length || !d.data[0]) {
						$scope.empty = true;
					} else {
						$scope.currencySymbol = d.targetCurrency ? d.targetCurrency : $rootScope.currencySymbol;
						var data = [];
						var stages = d.stages;
						var categories = [];
						var categoriesToId = {};
						var initiativeCount = 0;
						var totalSavings = 0;
						angular.forEach(d.data, function (chartData) {
							categories.push(chartData.code);
							categoriesToId[chartData.code] = chartData.id;
							initiativeCount += chartData.initiativeCount;
							totalSavings += chartData.totalSavings;
							delete chartData.code;
							delete chartData.initiativeCount;
							delete chartData.totalSavings;
						});
						$scope.chartData = d.data;
						$scope.chartCategories = categories;
						$scope.chartGroups = stages;
						$scope.initiativeCount = initiativeCount;
						$scope.totalSavings = totalSavings;
						$scope.categoriesCount = categories.length;
						$scope.targetCurrency = d.targetCurrency;
						$scope.categoriesToId = categoriesToId;
						$scope.$broadcast(initiativeChartProperties.eventName, null);
						$scope.savingsSelect = false;
					}
					$scope.$parent.$parent.hidePencil = false;
					if (!$scope.slideshowView) {
						pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
					}
				},
				function (e) {
					$scope.savingsSelect = false;
					$scope.empty = true;
					$scope.$parent.$parent.hidePencil = false;
					if (!$scope.slideshowView) {
						pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
					}
				}
			);
		}

		$scope.tableUrl = function () {
			return '/application/f/dashboard/widgets/lean-project-general-savings-table.html';
		};

		$scope.getEncodedValue = function(rawString) {
			return encodeURIComponent(rawString);
		};

		function getTable() {
			var filterQueryParams;
			if (!$scope.showTable) {
				pendo.track('widgetInteraction', {
					widgetType: $scope.config.type,
					interaction: 'showDetails'
				});
				$scope.loadingTable = true;
				$scope.tableHeading = initiativeChartProperties.translation[$scope.savings];
				leanProjectGeneralSavingsService.getTopLeanProjectsByViewType($scope.leanFilterService, $scope.viewType, $scope.displayType).then(
					function (d) {
					    // for backward compatibility set group by to viewType
					    $scope.groupBy = $scope.viewType;
						var savingsType = $scope.mode;
						if ($scope.displayType === 'numberOfProjects') {
							savingsType = 'Target ';
						} else if ($scope.savings === 'weightedSavings') {
							savingsType = '';
						} else { 
							savingsType += ' ';
						}
						savingsType += initiativeChartProperties.savingsTypeFilterTranslation[$scope.savings];
						var timePeriodParams = leanFilterService.getTimePeriodFilterQueryParam('timePeriod', $scope.filterService.getSelected('Time Period'), true, true);
						var archivedStageIds = null;
						if ($scope.filterService.getSelected('Lean Project Stage')) {
							archivedStageIds = $scope.filterService.getSelected('Lean Project Stage');
						} else {
							archivedStageIds = leanProjectSummaryService.getArchiveStageIds($scope.filterService.getObjectList('Lean Project Stage'));
							if (archivedStageIds.length == 0) {
								archivedStageIds = null;
							}
						}
						filterQueryParams = {
							'projectManagerId': $scope.filterService.getSelected('Lean Project Manager'),
							'projectType': $scope.filterService.getSelected('Lean Project Type'),
							'projectCategoryId': $scope.filterService.getSelected('Lean Project Category'),
							'projectGoalId': $scope.filterService.getSelected('Lean Project Goals'),
							'projectSavings': savingsType,
							'projectSavingsCategoryId': $scope.filterService.getSelected('ProjectSavingsCategories'),
							'stageId': archivedStageIds
						};
						filterQueryParams = _.merge(filterQueryParams, timePeriodParams);
						if ($scope.groupBy === 'Areas' || $scope.groupBy === 'BusinessUnit') {
							filterQueryParams['factory'] = $scope.filterService.getSelected('Factory');
							if ($scope.groupBy === 'Areas' && $scope.filterService.getSelected('Business Unit')) {
								filterQueryParams['businessunit'] = $scope.filterService.getSelected('Business Unit');
							}
						}
						if ($scope.groupBy !== 'Areas') {
							filterQueryParams['projectArea'] = $scope.filterService.getSelected('Lean Project Area');
						}
						filterQueryParams = jQuery.extend(true, {}, filterQueryParams);
						$scope.extraFilters = getQueryParam(filterQueryParams, false);
						addFilterQueryParam();
						$scope.data = d;
						$scope.empty = false;
						$scope.loadingTable = false;
						$scope.showTable = !$scope.showTable;
					},
					function (e) {
						$scope.error = e;
						$scope.loadingTable = false;
						$scope.showTable = !$scope.showTable;
					}
				);
			} else {
				$scope.showTable = !$scope.showTable;
			}
		}

		function addFilterQueryParam() {
			var queryFilterKey = '&filter=';
			var queryParamsObj =  leanFilterService.getQueryParamsObject();
			var queryFilterParam = queryParamsObj.filter;
			if (queryFilterParam) {
				$scope.extraFilters += queryFilterKey + queryFilterParam;
			}
		}

		updateEventBind($scope, ['sideBarUpdate', 'adfFactoryChanged',
			'slideshowViewChanged', 'leanProjectFilterChanged'
		]);

		var loadData = function () {
			if (!dashboardFilterInitializationService.updating['initialLoad']) {
				var columnDefinition = $scope.$parent.$parent.col;
				var curWidget = $scope.$parent.model;
				if (!$scope.slideshowView) {
					dashboardFilterInitializationService.markWidgetCreated('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
				}
				if (!$scope.savingsSelect) {
					getChart();
				}
			} else {
				$timeout(loadData, 100);
			}
		};

		loadData();
	}
})();
